import ExclamationCircle from '../src/ExclamationCircle';
export default ExclamationCircle;
